module.exports = __webpack_public_path__ + "images/Cloudera-d6a937.png";